import {useState,useEffect} from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Overview from './Overview'
import Charge from './Charge'
import Payments from './Payments/Payments'
import Packages from './Packages/Packages'
import Subscriptions from './Subscriptions/Subscriptions'
import ClientOverview from './ClientOverview/ClientOverview'
import Sessions from './Sessions/Sessions'
import MyProducts from './Products/MyProducts'
import Billing from './Billing/Billing'
import Tax from './Tax'
import Invoices from './Invoices/Invoices'
import CustomPayment from  './CustomPayment'
import usePayments from '../../hooks/usePayments'
import {
	useFinancialsDashboardTabs,
	usePurchaseAvailabilites
} from './hooks'
import BeginAcceptingPayments from '../BeginAcceptingPayments/BeginAcceptingPayments'
import useCurrentUser from '../../hooks/useCurrentUser'
import styles from './FinancialsDashboard.module.css'
import CenteredLoader from '../CenteredLoader/CenteredLoader'

const FinancialsDashboard = ({location})=>{
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	const isOwner = (
		(parseInt(user.gym_id) !== 0 && user.account_type==='gym') ||
		(parseInt(user.gym_id) === 0 && user.account_type==='trainer')
	)
	const {activeTab,setActiveTab} = useFinancialsDashboardTabs()
	const {enabled:paymentsEnabled,isSetup:paymentsAreSetup} = usePayments()
	const {status,availabilities} = usePurchaseAvailabilites()

	const keyComponentMap = {
		overview:(
			isClient
			? <ClientOverview/>
			: <Overview/>
		),
		payments:<Payments/>,
		subscriptions:<Subscriptions/>,
		sessions:<Sessions/>,
		myProducts:<MyProducts/>,
		packages:<Packages/>,
		customPayment:<CustomPayment/>,
		billing:<Billing/>,
		invoices:<Invoices/>,
		tax:<Tax/>,
		charge:<Charge/>
	}

	const userPageOptions = [
		{
			text:'Overview',
			key:'overview',
			hide:!isClient&&!isOwner
		},{
			text:'Payments',
			key:'payments',
			hide:!isOwner&&!isClient
		},{
			text:'Invoices',
			key:'invoices',
			hide:(!isClient||!availabilities.invoices)&&!isOwner
		},{
			text:'Packages',
			key:'packages',
			hide:isClient&&!availabilities.packages
		},{
			text:'Sessions',
			key:'sessions',
			hide:isClient&&!availabilities.sessions
		},{
			text:'Custom Payment',
			key:'customPayment',
			hide:(!isClient&&!isOwner)||!availabilities.custom_payment
		},{
			text:'Subscriptions',
			key:'subscriptions',
			hide:isClient&&!availabilities.subscriptions
		},{
			text:'Products',
			key:'myProducts',
			hide:isClient&&!availabilities.merchandise
		},{
			text:'Billing',
			key:'billing',
			hide:!isClient
		},
		{
			text:'Tax',
			key:'tax',
			hide:!isOwner
		},
		{
			text:'Charge Client',
			key:'charge',
			hide:!(isOwner || user.permissions.manage_billing)
		},
	]
	
	useEffect(()=>{
		const urlParams = new URLSearchParams(location.search)
		const defaultTab = (
			user.account_type === 'trainer'
			? 'packages'
			: 'overview'
		)
		setActiveTab(urlParams.get('tab')||defaultTab)
		//when navigating away reset financials to overview
		return ()=>{setActiveTab(defaultTab)}
	},[])

	//this should only happen for potential fraud
	//ie the user has setup payments AND has activity that 
	//matches fraud conditions
	if(!paymentsEnabled&&paymentsAreSetup) return (
		<div className="p-3 text-center">
			Please contact admin@fitsw.com to setup payments.
		</div>
	)

	if(!paymentsAreSetup) return (
		<BeginAcceptingPayments/>
	)

	if (status!=='idle') return (
		<CenteredLoader>
			Loading purchases and financials...
		</CenteredLoader>
	)

	return (
		<div style={{
			display:'flex',
			flexFlow:'column',
			alignItems:'stretch',
			width:'100%',
			height:'100%',
			overflow:'hidden',
			padding:'4px'
		}} className="py-2 px-2 px-md-3">
			<div id={styles.OptionsNav} className="mb-2">
				<strong>Select Financials Option</strong>
				<Form.Control 
					onChange={e=>{setActiveTab(e.target.value)}} 
					value={activeTab} 
					as="select"
				>
					{userPageOptions.map(opt=>(
						!Boolean(opt.hide)&&
						<option value={opt.key}>
								{opt.text}
						</option>
					))}
				</Form.Control>
			</div>
			<div id={styles.PillNav} style={{flex:'0 0 auto'}} className="mb-2" variant="pills">
				<span className="d-flex align-items-center mr-2">
					Financials:
				</span>
				{userPageOptions.map(opt=>(
					!Boolean(opt.hide)&&
					<Button 
						className="mr-1"
						variant={activeTab===opt.key?'primary':'outline-primary'}
						size="sm"
						onClick={()=>{setActiveTab(opt.key)}}>
						{opt.text}
					</Button>
				))}
			</div>
			<div style={{height:'100%',flex:'1 1 auto',overflow:'hidden'}}>
				{keyComponentMap[activeTab]}
			</div>
		</div>
	)
}

export default FinancialsDashboard